import { ShieldCheck } from "lucide-react";

export const PhishingTakeaway = () => {
  return (
    <div className="bg-gradient-to-r from-destructive/10 via-destructive/5 to-transparent rounded-2xl border border-destructive/20 p-6 sm:p-8">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 rounded-xl bg-destructive/20 flex items-center justify-center shrink-0">
          <ShieldCheck className="w-6 h-6 text-destructive" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-2">Key Takeaway</h3>
          <p className="text-muted-foreground leading-relaxed">
            Phishing attacks succeed because they exploit human psychology, not technical vulnerabilities. 
            The best defense is a combination of employee training, technical controls, and a culture where 
            reporting suspicious emails is encouraged and rewarded — not punished.
          </p>
        </div>
      </div>
    </div>
  );
};
